import React from 'react';
import I18nMessage from './I18nMessage';
import errorMessageConfig from './errorMessageConfig';

const ErrorMessages = {};

ErrorMessages.default = (
  contactSupportLink = 'https://activenetwork.my.salesforce-sites.com/usersupport/UScontact',
) => ({
  type: 'danger',
  contents: 'checkout.lib.layout.message.defaultErrorMessage',
  values: [
    <a key={0} href={contactSupportLink}>
      <I18nMessage id="checkout.lib.layout.message.defaultErrorMessage.contactSupport"/>
    </a>,
  ],
});

ErrorMessages.ERROR_NO_CREDENTIAL = ({ onUserLoginAction }) => {
  onUserLoginAction && onUserLoginAction();
  return undefined;
};

Object.keys(errorMessageConfig).forEach(
  (k, i) => {
    ErrorMessages[k] = (props) => {
      const handleClick = props[errorMessageConfig[k].action];
      return ({
        type: 'danger',
        contents: errorMessageConfig[k].contents,
        showErrorMsgOnly: errorMessageConfig[k].showErrorMsgOnly,
        values: [
          <span key={i} onClick={handleClick} className="link-style">
            <I18nMessage id={errorMessageConfig[k].linkErrorMessage}/>
          </span>,
        ],
      });
    };
  },
);

export default {
  error: ErrorMessages,
};
